import React from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";
import { ExdInfoTip } from "../../ExDashboard/components/ExdControls";
import { ExdWidgetSkeleton } from "../../ExDashboard/components/exdMui";
import { MD, mdCardSx, mdScrollbarSx } from "./mdTheme";
import MdPeriodSelect from "./MdPeriodSelect";

const MdCardHeader = ({
  eyebrow,
  title,
  crumb,
  infoTitle,
  controls,
  headValue,
  bigTitle = false,
}) => (
  <Stack
    direction="row"
    alignItems="flex-start"
    flexWrap="nowrap"
    spacing={1}
    sx={{ minWidth: 0, overflow: "hidden", width: "100%" }}
  >
    <Box sx={{ flex: "1 1 auto", minWidth: 0, overflow: "hidden" }}>
      <Typography
        component="div"
        sx={{
          alignItems: "center",
          color: "#4b5263",
          display: "flex",
          flexWrap: "nowrap",
          fontSize: 10.5,
          fontWeight: 700,
          gap: 0.75,
          letterSpacing: "0.12em",
          m: 0,
          minWidth: 0,
          overflow: "hidden",
          textTransform: "uppercase",
          "& > *": { minWidth: 0 },
        }}
      >
        <Box
          component="span"
          sx={{
            minWidth: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {eyebrow}
        </Box>
        {crumb ? (
          <Box
            component="span"
            sx={{
              color: MD.muted,
              flex: "none",
              fontFamily: MD.fontUi,
              fontSize: 12,
              fontWeight: 400,
              letterSpacing: 0,
              textTransform: "none",
            }}
          >
            {crumb}
          </Box>
        ) : null}
        <ExdInfoTip title={infoTitle} />
      </Typography>
      {title ? (
        <Typography
          component="h3"
          noWrap
          title={typeof title === "string" ? title : undefined}
          sx={{
            color: MD.fg,
            fontFamily: MD.fontHead,
            fontSize: bigTitle ? 22 : 14,
            fontWeight: bigTitle ? 700 : 600,
            lineHeight: 1.15,
            m: 0,
            mt: "3px",
            minWidth: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {title}
        </Typography>
      ) : null}
    </Box>
    {headValue ? (
      <Box sx={{ flex: "none", maxWidth: "42%", minWidth: 0 }}>{headValue}</Box>
    ) : null}
    {controls ? (
      <Stack
        direction="row"
        alignItems="center"
        spacing={0.75}
        sx={{ flex: "none", ml: "auto" }}
      >
        {controls}
      </Stack>
    ) : null}
  </Stack>
);

export const MdWidgetCard = ({
  loading,
  children,
  sx = {},
  bigTitle,
  fitContent = false,
  ...headerProps
}) => {
  const fitSx = fitContent
    ? { height: "auto", alignSelf: "start", flex: "0 0 auto" }
    : null;

  if (loading) {
    return (
      <Box sx={{ ...fitSx, width: "100%", minWidth: 0 }}>
        <ExdWidgetSkeleton />
      </Box>
    );
  }
  return (
    <Paper
      elevation={0}
      component="section"
      sx={{
        ...mdCardSx,
        ...fitSx,
        ...sx,
      }}
    >
      <MdCardHeader {...headerProps} bigTitle={bigTitle} />
      <Box
        sx={{
          display: "flex",
          flex: fitContent ? "0 0 auto" : "1 1 auto",
          flexDirection: "column",
          minHeight: 0,
          width: "100%",
        }}
      >
        {children}
      </Box>
    </Paper>
  );
};

export const MdScrollRank = ({ children, maxHeight = 300 }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      gap: 0.625,
      maxHeight,
      minWidth: 0,
      overflowX: "hidden",
      overflowY: "auto",
      pr: 0.5,
      width: "100%",
      ...mdScrollbarSx,
    }}
  >
    {children}
  </Box>
);

export { MdPeriodSelect };
export default MdCardHeader;
